module.exports = __webpack_public_path__ + "b5bbe4b5622309b02992e6ada49c00e7.png";